exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fill___fill___3xEK0 {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}", ""]);

// exports
exports.locals = {
	"fill": "fill___fill___3xEK0"
};